var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('search',{on:{"fetch-gifs":_vm.onFetch,"send-keyword":_vm.searchWord}}),_c('gif-list',{attrs:{"gifs":_vm.gifs}}),_c('app-footer',{attrs:{"keyword":_vm.keyword},on:{"fetch-gifs":_vm.onFetch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }